export const MAIN_VEHICLE = "MAIN_VEHICLE";
export const ESCORT_VEHICLE = "ESCORT_VEHICLE";
export const TRAILER = "TRAILER";
